//import { ApplicantOfferRequirementTask } from './offer/enums';

export enum ApplicantStatus {
  New = 'NEW',
}

export enum FingerStatus {
  Todo = 'Todo',
  InProgress = 'InProgress',
  Complete = 'Complete',
  InError = 'InError',
  Rejected = 'Rejected',
  Waiting = 'Waiting',
  Locked = 'Locked',
  None = 'None',
}

export enum StudyLevel {
  Foundation = 'Foundation',
  Undergraduate = 'Undergraduate',
  Postgraduate = 'Postgraduate',
  Research = 'Research',
}
export enum StudyMode {
  FullTime = 'Full-time',
  PartTime = 'Part-time',
  MixedMode = 'Mixed-mode',
  Sandwich = 'Sandwich',
  DistanceLearning = 'Distance-learning',
}

export enum PreviousStudyLevel {
  HighSchool = 'HighSchool',
  Undergraduate = 'Undergraduate',
  Postgraduate = 'Postgraduate',
}

export enum GradeLevel {
  HighSchool = 'High School',
  GcseEnglish = 'GCSE',
  AsLevel = 'AS Level',
  ALevel = 'A Level',
  InternationalBaccalaureateDiploma = 'International Baccalaureate Diploma',
  UniversityFoundation = 'University Foundation',
  CertificateOfHigherEducation = 'Certificate of Higher Education',
  DiplomaOfHigherEducation = 'Diploma of Higher Education (DipHE)',
  HigherNationalDiploma = 'Higher National Diploma (HND)',
  BachelorDegree = 'Bachelor Degree',
  MastersDegree = 'Masters Degree',
  GraduateCertificateOrDiploma = 'Graduate Certificate or Diploma',
  PostGraduateCertificateOrDiploma = 'Post Graduate Certificate or Diploma',
  ResearchDegree = 'Research degree',
  Other = 'Other',
}

export enum GradeSystem {
  DegreeClassification = 'Degree classification',
  Gpa4 = 'GPA 4',
  Gpa5 = 'GPA 5',
  Gpa10 = 'GPA 10',
  LetterGrade = 'Letter grade',
  PassFail = 'Pass/Fail',
  Percentage = 'Percentage',
  Other = 'Other',
}

export enum FeeStatus {
  Home = 'HOME',
  Overseas = 'OVERSEAS',
  NotSure = 'NOT_SURE',
}

export enum ResultStatus {
  FinalResults = 'FinalResults',
  InterimResults = 'InterimResults',
  NoResults = 'NoResults',
}

export enum Ethnicity {
  Arab = 'Arab',
  AsianBangladeshi = 'Asian - Bangladeshi',
  AsianChinese = 'Asian - Chinese',
  AsianIndian = 'Asian - Indian',
  AsianPakistani = 'Asian - Pakistani',
  AsianOther = 'Asian - Other background',
  BlackAfrican = 'Black - African',
  BlackCaribbean = 'Black - Caribbean',
  BlackOther = 'Black - Other background',
  GypsyTraveller = 'Gypsy, Traveller or Irish Traveller',
  MixedWhiteAsian = 'Mixed - White & Asian',
  MixedWhiteBlackAfrican = 'Mixed - White & Black African',
  MixedWhiteBlackCaribbean = 'Mixed - White & Black Caribbean',
  MixedOther = 'Mixed - Other background',
  White = 'White',
  WhiteIrish = 'White - Irish',
  WhiteRoma = 'White - Roma',
  WhiteOther = 'White - Other background',
  Other = 'Other ethnic background',
  PreferNotToSay = 'I prefer not to say',
}

export enum DisabilityTypeDescription {
  VisualImpairment = 'e.g. blindness or partial sight',
  HearingImpairment = 'e.g. deafness or partial hearing',
  MentalHealthCondition = 'e.g., anxiety or depression',
  LearningDifficulty = 'e.g., dyslexia, dyspraxia, or ADHD/ADD',
  PhysicalImpairment = 'e.g., climbing stairs or uneven surfaces, using a keyboard or laboratory equipment',
  SocialBehaviouralImpairment = "e.g., an autistic spectrum condition, Tourette's Syndrome, or speech and language difficulties, including stammering",
  MultiDomainCondition = 'e.g. downs syndrome, shaken baby syndrome, childhood encephalitis, cerebral palsy, muscular dystrophy, spastic limb, neurodiversity, childhood related legacy impacts and conditions, elective mutism, abuse or trauma linked speech delays, stutters or stammers, specific medical conditions or region specific brain injuries',
}

export enum DisabilityType {
  VisualImpairment = 'A visual impairment uncorrected by glasses',
  HearingImpairment = 'A hearing impairment',
  MentalHealthCondition = 'A mental health condition, challenge, or disorder',
  LearningDifficulty = 'A learning difficulty',
  PhysicalImpairment = 'A physical impairment, including challenges with mobility or dexterity',
  LongTermIllness = 'A long-term illness or health condition that may cause pain, fatigue, loss of concentration, or breathing difficulties \u2013 including any effects from related medication',
  SocialBehaviouralImpairment = 'A social, behavioural, or communication impairment',
  MultiDomainCondition = 'A development condition since childhood which affects motor, cognitive, social and emotional skills, speech, and language',
  NotListed = 'A condition or impairment not listed',
}

export enum SchoolType {
  UkState = 'UK State School',
  UkIndependent = 'UK Independent (i.e. Private) School',
  UkFurtherEducation = 'UK Further Education College',
  UkHigherEducation = 'UK Higher Education College',
  NonUkSchool = 'Non-UK School, College or University',
  OtherUkProvider = 'Other UK training provider',
}

export enum HelpingSubmit {
  Agent = 'Agent',
  ThirdParty = 'ThirdParty',
  Option3 = 'Option3',
}

export enum ThirdParty {
  Option1 = 'Option1',
  Option2 = 'Option2',
  Option3 = 'Option3',
}

export enum FirstApplicationStatus {
  FirstTime = 'FirstTime',
  AppliedOnly = 'AppliedOnly',
  StudiedBefore = 'StudiedBefore',
}

export enum ReferralSource {
  Agent = 'AGENT',
  CampusVisit = 'CAMPUS_VISIT',
  EducationFair = 'EDUCATION_FAIR',
  FamilyMember = 'FAMILY_MEMBER',
  Friend = 'FRIEND',
  OnlineSearch = 'ONLINE_SEARCH',
  SchoolCounselor = 'SCHOOL_COUNSELOR',
  SocialMedia = 'SOCIAL_MEDIA',
  Teacher = 'TEACHER',
  Ucas = 'UCAS',
  UniversityStudent = 'UNIVERSITY_STUDENT',
  UniversityWebsite = 'UNIVERSITY_WEBSITE',
  Other = 'OTHER',
  PreferNotToSay = 'PREFER_NOT_TO_SAY',
}

export enum IDType {
  Passport = 'Passport',
  Id = 'ID',
  None = 'None',
}

export enum Gender {
  Male = 'Male',
  Female = 'Female',
  NotListed = 'Not Listed',
}

export enum GenderIdentity {
  Man = 'Man',
  Women = 'Women',
  AnotherTerm = 'I use another term',
  PreferNotToSay = 'I prefer not to say',
}

export enum EnglishTestType {
  IeltsForUkvi = 'IELTS for UKVI',
  IeltsAcademic = 'IELTS Academic',
  Ielts = 'IELTS General',
  EsolSelt = 'LanguageCert International ESOL SELT',
  Ise = 'Trinity College London Integrated Skills in English (ISE)',
  PteUkvi = 'PTE Academic UKVI',
  Pte = 'PTE Academic',
  Psi = 'PSI Services Skills for English UKVI',
  Cambridge = 'Cambridge Assessment English test',
  Toefl = 'TOEFL',
  Uni = "University's English test",
  Ellt = 'OI Digital Institute English Language Level Test (ELLT)',
  Other = 'Other',
}

export enum EnglishTestNotReqdReason {
  MajEngCountry = 'I am a national of a majority English-speaking country',
  PlanTest = 'I plan to take an English language test to meet the requirements',
  PrevQual = 'My English can be assessed based on my previous academic qualification',
  PrevVisa = 'I have met the English language requirement in my previous visa application',
  UsStudyProgram = "I'm coming as a part of US study abroad programme",
  Other = 'Other/I don’t know',
}

export enum EmploymentType {
  FullTime = 'Full Time',
  PartTime = 'Part Time',
  Casual = 'Casual',
  Freelance = 'Freelance',
  Contract = 'Contract',
  Temporary = 'Temporary',
  Volunteer = 'Volunteer',
  Apprenticeship = 'Apprenticeship',
  WorkExperience = 'Work Experience',
  Other = 'Other',
}

export enum UkAccommodationType {
  UniversityAccommodation = 'University accommodation',
  PrivateStudentAccommodation = 'Private student accommodation',
  PrivateRental = 'Private rental',
  StayingWithFamily = 'Staying with family',
  Homestay = 'Homestay',
  Other = 'Other',
}

export enum VisaType {
  ShortTermStudyStudentVisa = 'Short-term study / student visa',
  StudentVisa = 'Student visa (Tier 4 General/Student Route)',
  ChildStudentVisa = 'Child Student visa (Tier 4 Child/Child Student Route)',
  Other = 'Other (my visa is not listed here)',
}

export enum VisaLevelOfStudy {
  HighSchool = 'High School',
  Foundation = 'Foundation',
  Bachelor = 'Bachelor (UG)',
  Masters = 'Masters (PG)',
  Research = 'Research (PhD etc.)',
  ShortCourse = 'Short Course',
  EnglishLanguageCourse = 'English Language Course',
}

export enum CourseCompare {
  HigherLevelCourse = 'The course I am applying for now is at a higher level',
  SameLevelCourse = 'The course I am applying for now is at the same level',
  LowerLevelCourse = 'The course I am applying for now is at a lower level',
  NoUkAcademicStudy = 'I have not studied any academic courses in the UK',
}

export enum VisaOrPermitType {
  PreSettledStatus = 'Pre-settled status under the EU Settlement Scheme',
  SettledStatus = 'Settled status under the EU Settlement Scheme',
  IndefiniteLeaveToRemain = 'Indefinite leave to remain',
  LeaveToRemain = 'Leave to remain',
  UkraineSchemeVisa = 'Ukraine scheme visa',
  PartnerChildBritishIlr = 'Partner or child visa of someone with British citizenship or ILR',
  PartnerChildWorkStudy = 'Partner or child visa of someone with a work or study visa',
  EuFamilyDependant = 'EU or EEA family member/dependant',
  DependantVisa = 'Dependant visa',
  WorkVisa = 'Work visa',
  PendingEussApplication = 'Pending application for EUSS with certificate of application',
  AsylumSeeker = 'Asylum seeker',
  Refugee = 'Refugee',
  HumanitarianProtection = 'Humanitarian Protection',
  ChildOfTurkishWorker = 'Child of a Turkish Worker',
  TouristVisitorVisa = 'Tourist / visitor visa',
  VisaNotListed = 'My visa or permit are not listed',
}

export enum VisaOrPermitStatus {
  VisaNotListed = 'VISA_NOT_LISTED',
}

export enum RefusedVisaType {
  TouristVisitorVisa = 'Tourist / visitor visa',
  InnovatorVisa = 'Innovator visa',
  StartupVisa = 'Start-up visa',
  InvestorEntrepreneurVisa = 'Investor / entrepreneur visa (Tier 1)',
  ExceptionalTalentVisa = 'Exceptional talent visa (Tier 1)',
  GraduateEntrepreneurVisa = 'Graduate Entrepreneur visa (Tier 1)',
  LongTermWorkVisa = 'Long-term work visa (Tier 2)',
  ShortTermWorkVisa = 'Short-term work visa (Tier 5)',
  IntraCompanyTransferVisa = 'Intra-company Transfer visa (Tier 2)',
  MinisterOfReligionVisa = 'Minister of Religion visa (Tier 2)',
  SportspersonVisa = 'Sportsperson visa (Tier 2)',
  LowSkilledWorkerVisa = 'Low Skilled Worker (Tier 3)',
  StandardVisitorVisa = 'Standard Visitor visa',
  MarriageVisitorVisa = 'Marriage Visitor visa',
  PaidEngagementVisa = 'Permitted Paid Engagement visa',
  ParentTier4ChildVisa = 'Parent of a Tier 4 child visa',
  ChineseTourGroupVisa = 'Visit the UK in a Chinese tour group',
  TransitVisa = 'Visa to pass through the UK in transit',
  ShortTermStudyVisa = 'Short-term study / student visa',
  StudentVisa = 'Student visa (Tier 4 General/Student Route)',
  ChildStudentVisa = 'Child Student visa (Tier 4 Child/Child Student Route)',
  TempWorkCharityVisa = 'Temporary Worker - Charity Worker visa (Tier 5)',
  TempWorkCreativeSportingVisa = 'Temporary Worker - Creative and Sporting visa (Tier 5)',
  TempWorkAuthorisedExchangeVisa = 'Temporary Worker - Government Authorised Exchange visa (Tier 5)',
  TempWorkIntlAgreementVisa = 'Temporary Worker - International Agreement visa (Tier 5)',
  TempWorkReligiousWorkerVisa = 'Temporary Worker - Religious Worker visa (Tier 5)',
  TempWorkSeasonalWorkerVisa = 'Temporary Worker - Seasonal Worker Visa (Tier 5)',
  YouthMobilitySchemeVisa = 'Youth mobility scheme visa (Tier 5)',
  FamilyVisa = 'Family visas: apply, extend or switch',
  EuEeaFamilyPermit = 'Apply for a permit to join your EU or EEA family member in the UK',
  DependantVisa = 'Dependant Visa',
  OtherVisaNotListed = 'Other (My visa is not listed here)',
}

export enum ApplyDocTypes {
  Lead = 'LEAD',
  Applicant = 'APPLICANT_DETAILS',
  StudyHistory = 'APPLICANT_STUDY_HISTORY',
  Application = 'APPLICATION',
  ApplicationSummary = 'APPLICATION_SUMMARY',
  Document = 'APPLICANT_DOCUMENT',
  Offer = 'APPLICANT_OFFER',
  OfferRequirement = 'APPLICANT_OFFER_REQUIREMENT',
  OfferSummary = 'APPLICANT_OFFER_SUMMARY',
  OfferPayment = 'APPLICANT_OFFER_PAYMENT',
  Course = 'APPLY_COURSE',
  UniRequirement = 'APPLY_UNI_REQUIREMENT',
  ApplicationTaskConfig = 'APPLY_APPLICATION_TASK_CONFIG',
  EllucianReferenceData = 'ELLUCIAN_REFERENCE_DATA',
  CourseTaskRulesConfig = 'APPLY_COURSE_TASK_RULES_CONFIG',
}

export enum ApplicationStatus {
  InProgress = 'InProgress',
  Completed = 'Completed',
  Submitted = 'Submitted',
  AwaitingDecision = 'AwaitingDecision',
  Offered = 'Offered',
  Accepted = 'Accepted',
  Rejected = 'Rejected',
  Withdrawn = 'Withdrawn',
  Cancelled = 'Cancelled',
}

export enum ApplicationRefereeRelation {
  Manager = 'Manager',
  Colleague = 'Colleague',
  Teacher = 'Teacher',
  CareersAdvisor = 'Careers advisor',
  Other = 'Other',
}

export enum FundingOption {
  PrivateFinance = 'PrivateFinance',
  StudentFinance = 'StudentFinance',
  HealthAuthority = 'HealthAuthority',
  ResearchCouncils = 'ResearchCouncils',
  TrainingAgency = 'TrainingAgency',
  UkIndustry = 'UkIndustry',
  UkGovtInternational = 'UkGovtInternational',
  UkGovtOther = 'UkGovtOther',
  UniversityScholarship = 'UniversityScholarship',
  OverseasAgency = 'OverseasAgency',
  OverseasGovt = 'OverseasGovt',
  OverseasIndustry = 'OverseasIndustry',
  OverseasUniversity = 'OverseasUniversity',
  Other = 'Other',
  Unknown = 'Unknown',
}

export enum RepresentationHelpedBy {
  Agent = 'AGENT',
  FamilyMember = 'FAMILY_MEMBER',
  Friend = 'FRIEND',
  SchoolCounselor = 'SCHOOL_COUNSELOR',
  Teacher = 'TEACHER',
  UniversityStudent = 'UNIVERSITY_STUDENT',
  Other = 'OTHER',
}

export enum StatusColor {
  Todo = 'orange',
  Done = 'green',
  Locked = 'gray',
}

export enum ConfirmationOptions {
  Yes = 'Yes',
  No = 'No',
}

export enum ResidentialCategoryOptions {
  UkCitizenEngland = 'UK Citizen - England',
  UkCitizenScotland = 'UK Citizen - Scotland',
  UkCitizenWales = 'UK Citizen - Wales',
  UkCitizenNorthernIreland = 'UK Citizen - Northern Ireland',
  BritishCitizenChannelIslandsAndIsleOfMan = 'British Citizen - Channel Islands and Isle of Man',
  BritishCitizenBritishOverseasTerritories = 'British Citizen - British Overseas Territories',
  EuNationalNonUkCitizen = 'EU National (non-UK Citizen)',
  EeaOrSwissNational = 'EEA or Swiss National',
  ChildOfATurkishWorker = 'Child of a Turkish Worker',
  Refugee = 'Refugee',
  HumanitarianProtectionOrSimilar = 'Humanitarian Protection or similar',
  SettledInTheUk = 'Settled in the UK',
  Other = 'Other',
}

export enum UkAreaOptions {
  Aberdeen = 'Aberdeen',
  Aberdeenshire = 'Aberdeenshire',
  Alderney = 'Alderney',
  Angus = 'Angus',
  ArgyllAndBute = 'Argyll & Bute',
  BarkingAndDagenham = 'Barking and Dagenham',
  Barnet = 'Barnet',
  Barnsley = 'Barnsley',
  BathAndNorthEastSomerset = 'Bath and North East Somerset',
  Bedfordshire = 'Bedfordshire',
  Belfast = 'Belfast',
  Bexley = 'Bexley',
  Birmingham = 'Birmingham',
  BlackburnWithDarwen = 'Blackburn with Darwen',
  Blackpool = 'Blackpool',
  BlaenauGwent = 'Blaenau Gwent',
  Bolton = 'Bolton',
  Bournemouth = 'Bournemouth',
  BracknellForest = 'Bracknell Forest',
  Bradford = 'Bradford',
  Brent = 'Brent',
  Bridgend = 'Bridgend',
  BrightonAndHove = 'Brighton and Hove',
  Bristol = 'Bristol',
  Bromley = 'Bromley',
  Buckinghamshire = 'Buckinghamshire',
  Bury = 'Bury',
  Caerphilly = 'Caerphilly',
  Calderdale = 'Calderdale',
  Cambridgeshire = 'Cambridgeshire',
  Camden = 'Camden',
  Cardiff = 'Cardiff',
  Carmarthenshire = 'Carmarthenshire',
  Ceredigion = 'Ceredigion',
  Cheshire = 'Cheshire',
  CityOfLondon = 'City of London',
  Clackmannanshire = 'Clackmannanshire',
  Conwy = 'Conwy',
  Cornwall = 'Cornwall',
  CountyAntrim = 'County Antrim',
  CountyArmagh = 'County Armagh',
  CountyDerryLondonderry = 'County Derry/Londonderry',
  CountyDown = 'County Down',
  CountyFermanagh = 'County Fermanagh',
  CountyTyrone = 'County Tyrone',
  Coventry = 'Coventry',
  Croydon = 'Croydon',
  Cumbria = 'Cumbria',
  Darlington = 'Darlington',
  Denbighshire = 'Denbighshire',
  Derby = 'Derby',
  Derbyshire = 'Derbyshire',
  Devon = 'Devon',
  Doncaster = 'Doncaster',
  Dorset = 'Dorset',
  Dudley = 'Dudley',
  DumfriesAndGalloway = 'Dumfries & Galloway',
  Dundee = 'Dundee',
  Durham = 'Durham',
  Ealing = 'Ealing',
  EastAyrshire = 'East Ayrshire',
  EastDunbartonshire = 'East Dunbartonshire',
  EastLothian = 'East Lothian',
  EastRenfrewshire = 'East Renfrewshire',
  EastRidingOfYorkshire = 'East Riding of Yorkshire',
  EastSussex = 'East Sussex',
  Edinburgh = 'Edinburgh',
  Enfield = 'Enfield',
  Essex = 'Essex',
  Falkirk = 'Falkirk',
  Fife = 'Fife',
  Flintshire = 'Flintshire',
  Gateshead = 'Gateshead',
  Glasgow = 'Glasgow',
  Gloucestershire = 'Gloucestershire',
  Greenwich = 'Greenwich',
  Guernsey = 'Guernsey',
  Gwynedd = 'Gwynedd',
  Hackney = 'Hackney',
  Halton = 'Halton',
  HammersmithAndFulham = 'Hammersmith and Fulham',
  Hampshire = 'Hampshire',
  Haringey = 'Haringey',
  Harrow = 'Harrow',
  Hartlepool = 'Hartlepool',
  Havering = 'Havering',
  Herefordshire = 'Herefordshire',
  Hertfordshire = 'Hertfordshire',
  Highland = 'Highland',
  Hillingdon = 'Hillingdon',
  Hounslow = 'Hounslow',
  Inverclyde = 'Inverclyde',
  IsleOfAnglesey = 'Isle of Anglesey',
  IsleOfMan = 'Isle of Man',
  IsleOfWight = 'Isle of Wight',
  IslesOfScilly = 'Isles of Scilly',
  Islington = 'Islington',
  Jersey = 'Jersey',
  KensingtonAndChelsea = 'Kensington and Chelsea',
  Kent = 'Kent',
  KingstonUponHull = 'Kingston upon Hull',
  KingstonUponThames = 'Kingston upon Thames',
  Kirklees = 'Kirklees',
  Knowsley = 'Knowsley',
  Lambeth = 'Lambeth',
  Lancashire = 'Lancashire',
  Leeds = 'Leeds',
  Leicester = 'Leicester',
  Leicestershire = 'Leicestershire',
  Lewisham = 'Lewisham',
  Lincolnshire = 'Lincolnshire',
  Liverpool = 'Liverpool',
  Luton = 'Luton',
  Manchester = 'Manchester',
  Medway = 'Medway',
  MerthyrTydfil = 'Merthyr Tydfil',
  Merton = 'Merton',
  Middlesbrough = 'Middlesbrough',
  Midlothian = 'Midlothian',
  MiltonKeynes = 'Milton Keynes',
  Monmouthshire = 'Monmouthshire',
  Moray = 'Moray',
  NeathPortTalbot = 'Neath Port Talbot',
  NewcastleUponTyne = 'Newcastle upon Tyne',
  Newham = 'Newham',
  Newport = 'Newport',
  Norfolk = 'Norfolk',
  NorthAyrshire = 'North Ayrshire',
  NorthEastLincolnshire = 'North East Lincolnshire',
  NorthLanarkshire = 'North Lanarkshire',
  NorthLincolnshire = 'North Lincolnshire',
  NorthSomerset = 'North Somerset',
  NorthTyneside = 'North Tyneside',
  NorthYorkshire = 'North Yorkshire',
  Northamptonshire = 'Northamptonshire',
  Northumberland = 'Northumberland',
  Nottingham = 'Nottingham',
  Nottinghamshire = 'Nottinghamshire',
  Oldham = 'Oldham',
  OrkneyIslands = 'Orkney Islands',
  Oxfordshire = 'Oxfordshire',
  Pembrokeshire = 'Pembrokeshire',
  PerthshireKinross = 'Perthshire & Kinross',
  Peterborough = 'Peterborough',
  Plymouth = 'Plymouth',
  Poole = 'Poole',
  Portsmouth = 'Portsmouth',
  Powys = 'Powys',
  Reading = 'Reading',
  Redbridge = 'Redbridge',
  RedcarAndCleveland = 'Redcar and Cleveland',
  Renfrewshire = 'Renfrewshire',
  RhonddaCynonTaff = 'Rhondda, Cynon, Taff',
  RichmondUponThames = 'Richmond upon Thames',
  Rochdale = 'Rochdale',
  Rotherham = 'Rotherham',
  Rutland = 'Rutland',
  Salford = 'Salford',
  Sandwell = 'Sandwell',
  ScottishBorders = 'Scottish Borders',
  Sefton = 'Sefton',
  Sheffield = 'Sheffield',
  ShetlandIslands = 'Shetland Islands',
  Shropshire = 'Shropshire',
  Slough = 'Slough',
  Solihull = 'Solihull',
  Somerset = 'Somerset',
  SouthAyrshire = 'South Ayrshire',
  SouthGloucestershire = 'South Gloucestershire',
  SouthLanarkshire = 'South Lanarkshire',
  SouthTyneside = 'South Tyneside',
  Southampton = 'Southampton',
  SouthendOnSea = 'Southend on Sea',
  Southwark = 'Southwark',
  StHelens = 'St.Helens',
  Staffordshire = 'Staffordshire',
  Stirling = 'Stirling',
  Stockport = 'Stockport',
  StocktonOnTees = 'Stockton-on-Tees',
  StokeOnTrent = 'Stoke-on-Trent',
  Suffolk = 'Suffolk',
  Sunderland = 'Sunderland',
  Surrey = 'Surrey',
  Sutton = 'Sutton',
  Swansea = 'Swansea',
  Swindon = 'Swindon',
  Tameside = 'Tameside',
  TelfordAndWrekin = 'Telford and Wrekin',
  TheRoyalBoroughOfWindsorMaidenheadAndBerkshire = 'The Royal Borough of Windsor, Maidenhead and Berkshire',
  Thurrock = 'Thurrock',
  Torbay = 'Torbay',
  Torfaen = 'Torfaen',
  TowerHamlets = 'Tower Hamlets',
  Trafford = 'Trafford',
  ValeOfGlamorgan = 'Vale of Glamorgan',
  Wakefield = 'Wakefield',
  Walsall = 'Walsall',
  WalthamForest = 'Waltham Forest',
  Wandsworth = 'Wandsworth',
  Warrington = 'Warrington',
  Warwickshire = 'Warwickshire',
  WestBerkshire = 'West Berkshire',
  WestDunbartonshire = 'West Dunbartonshire',
  WestLothian = 'West Lothian',
  WestSussex = 'West Sussex',
  WesternIsles = 'Western Isles',
  Westminster = 'Westminster',
  Wigan = 'Wigan',
  Wiltshire = 'Wiltshire',
  Wirral = 'Wirral',
  Wokingham = 'Wokingham',
  Wolverhampton = 'Wolverhampton',
  Worcestershire = 'Worcestershire',
  Wrexham = 'Wrexham',
  York = 'York',
}

export enum DocumentType {
  AcademicTranscript = 'academicTranscript',
  Passport = 'passport',
  PersonalStatement = 'personalStatement',
  PhotoId = 'photoId',
  CV = 'cv',
  EnglishTest = 'englishTest',
  ReferenceLetter = 'referenceLetter', // AKA letterOfRecommendation
  AcademicCertificate = 'academicCertificate',
  ProofOfAddress = 'proofOfAddress',
  ProofOfNameChange = 'proofOfNameChange',
  NameAffidavit = 'nameAffidavit',
  BirthCert = 'birthCert',
  ProofOfImmigrationStatus = 'proofOfImmigrationStatus',
  ProofOfManagerialExperience = 'proofOfManagerialExperience',
  ProofOfPayment = 'proofOfPayment',
  Portfolio = 'portfolio',
  ResearchProposal = 'researchProposal',
  CustomRequest = 'customRequest',
  CustomRequirement = 'customRequirement',
  StaffDocument = 'staffDocument',
  StaffOnlyRequirement = 'staffOnlyRequirement',
}

export enum AgentApplicantAuthorisationStatus {
  AUTHORISED = 'AUTHORISED',
  AUTHORISATION_DENIED = 'AUTHORISATION_DENIED',
  AUTHORISATION_PENDING = 'AUTHORISATION_PENDING',
}

export enum SummaryTypeId {
  ApplicationSummary = ApplyDocTypes.ApplicationSummary,
  OfferSummary = ApplyDocTypes.OfferSummary,
}

export enum Workflows {
  ADMISSIONS = 'Admissions',
  CAS = 'CAS process',
}

export enum WorkflowAccessLevel {
  AdmissionsAccess = 'Admissions',
  CasAccess = 'CAS process',
  FullAccess = 'Full access',
}

export enum EmailStatus {
  NoEmail = 'No email',
}

export enum CourseAvailability {
  ALL = 'all',
  LIMITED_PARTNERS = 'limited_partners',
}
